var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('div',{staticClass:"page-not-found__inner"},[_c('img',{staticClass:"page-not-found__inner-img",attrs:{"src":require("./404.png")}}),_vm._v(" "),_c('p',{staticClass:"page-not-found__inner-text"},[_vm._v(_vm._s(_vm.displayContext))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }